function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

export { getDefaultExportFromCjs as g };
//# sourceMappingURL=_commonjsHelpers-B85MJLTf.js.map
